import { style } from 'typestyle'
export const pr16 = style({ paddingRight: '16px' })
